<template>
  <div id="Bidding"><MainBidding /></div>
</template>

<script>
import MainBidding from "../components/Bidding/MainBidding.vue";
export default {
  name: "Bidding",
  components: {
    MainBidding,
  },
};
</script>

<style></style>
